import { render, staticRenderFns } from "./MyWalletTokensNftsSection.vue?vue&type=template&id=5000a606&scoped=true"
import script from "./MyWalletTokensNftsSection.vue?vue&type=script&lang=ts"
export * from "./MyWalletTokensNftsSection.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletTokensNftsSection.vue?vue&type=style&index=0&id=5000a606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000a606",
  null
  
)

export default component.exports